export const VERIFICATION_STATUS = {
  NONE: 'None',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  NOT_APPROVED: 'Not Approved',
  DRAFT: 'Draft',
  FAILED: 'Failed'
};
